// TODO: reference internal Intercom article maintained by CS once available for all of the relevant roles and permissions

export const RESTRICTIONS = {
  VIEW_ONLY_ADMIN: "RESTRICTION_VIEW_ONLY_ADMIN",
  CLASSROOM_VIEW_ONLY: "RESTRICTION_CLASSROOM_VIEW_ONLY",
  CLASSROOM_REQUESTER: "RESTRICTION_CLASSROOM_REQUESTER",
  CANNOT_EDIT_SCHOOL_PROFILE: "RESTRICTION_CANNOT_EDIT_SCHOOL_PROFILE",
  CANNOT_CREATE_ADMINS: "RESTRICTION_CANNOT_CREATE_ADMINS",
  HIDE_SUB_FEEDBACK: "RESTRICTION_HIDE_SUB_FEEDBACK",
};

export const COMBINED_RESTRICTIONS = {
  VIEW_SUB_PAY: [
    RESTRICTIONS.VIEW_ONLY_ADMIN,
    RESTRICTIONS.CLASSROOM_VIEW_ONLY,
    RESTRICTIONS.CLASSROOM_REQUESTER,
  ],
  GET_REQ_CSV: [RESTRICTIONS.CLASSROOM_VIEW_ONLY, RESTRICTIONS.CLASSROOM_REQUESTER],
  EDIT_TEACHER: [RESTRICTIONS.CLASSROOM_REQUESTER, RESTRICTIONS.CLASSROOM_VIEW_ONLY],
  CHOOSE_SUB: [RESTRICTIONS.VIEW_ONLY_ADMIN, RESTRICTIONS.CLASSROOM_VIEW_ONLY],
  EDIT_SCHOOL_PROFILE: [
    RESTRICTIONS.CANNOT_EDIT_SCHOOL_PROFILE,
    RESTRICTIONS.VIEW_ONLY_ADMIN,
    RESTRICTIONS.CLASSROOM_VIEW_ONLY,
    RESTRICTIONS.CLASSROOM_REQUESTER,
  ],
  VIEW_ALL_ADMINS: [
    RESTRICTIONS.CANNOT_CREATE_ADMINS,
    RESTRICTIONS.VIEW_ONLY_ADMIN,
    RESTRICTIONS.CLASSROOM_VIEW_ONLY,
    RESTRICTIONS.CLASSROOM_REQUESTER,
  ],
  CREATE_ADMINS: [
    RESTRICTIONS.CANNOT_CREATE_ADMINS,
    RESTRICTIONS.VIEW_ONLY_ADMIN,
    RESTRICTIONS.CLASSROOM_VIEW_ONLY,
    RESTRICTIONS.CLASSROOM_REQUESTER,
  ],
  EDIT_REQUESTS: [RESTRICTIONS.VIEW_ONLY_ADMIN, RESTRICTIONS.CLASSROOM_VIEW_ONLY],
  VIEW_REQUESTS_FOR_OTHERS: [RESTRICTIONS.CLASSROOM_VIEW_ONLY, RESTRICTIONS.CLASSROOM_REQUESTER],
  CLASSROOM_ADMIN: [RESTRICTIONS.CLASSROOM_VIEW_ONLY, RESTRICTIONS.CLASSROOM_REQUESTER],
};

const isSubset = (a: string[], b: string) => {
  return a?.includes(b);
};

export const doRestrictionsOverlap = (
  userRestrictions: Array<string>,
  predicate: Array<string | string[]>,
) => {
  const flattenedPredicateList = predicate.flat(2); // flat depth of 2 is enough - predicate
  // will either be an array or an array of arrays.
  const intersectedItems = flattenedPredicateList.filter((item) =>
    isSubset(userRestrictions, item),
  );
  return intersectedItems.length > 0;
};
